const TOKEN = /^\{var\.([^}]+)\}$/;

export function getVariableTokenId(value: unknown): string | null {
	return typeof value == 'string' ? (TOKEN.exec(value)?.[1] ?? null) : null;
}
